let ResizeObserver;

if (typeof window !== 'undefined') {
  ResizeObserver = window.ResizeObserver || require('resize-observer-polyfill').default;
}

export default ResizeObserver;
